import MoreAccount from '@/images/onboarding/moreAccount180.png';
import Top from '@/images/onboarding/top180.png';
import MultipleFiles from '@/images/onboarding/multiple_files180.png';
import MailClassify from '@/images/onboarding/mail_classify180.png';
import FeedbackImg from '@/images/onboarding/feedback180.png';
import MailTemplate from '@/images/onboarding/template180.png';
import MailSignature from '@/images/onboarding/signature180.png';
import MailAggregation from '@/images/onboarding/aggregation180.png';
import Read from '@/images/onboarding/read180.png';
import Withdraw from '@/images/onboarding/withdraw180.png';
import Flag from '@/images/onboarding/flag180.png';
import Native from '@/images/onboarding/native180.png';
import { apiHolder, apis, getIn18Text } from 'api';
const eventApi = apiHolder.api.getEventApi();
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
export const configMap = {
    moreAccount: {
        title: getIn18Text('TIANJIAYOUXGXGL'),
        desc: getIn18Text('TIANJIANINDGZYXTYGXY5'),
        imgUrl: MoreAccount,
        btn: {
            txt: `<span class="u-empty-more-account">
        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACQSURBVHgB7ZXNCYRADIVfxAJ2S9gO7GO1D/VmJR4tQy+etQRL0BKsIAbRg8II8edkvsOEgSSPGV4IYNxJlHD+j7nS1PiaZAYC8kCaGg8PYwIvENhYLky4lPA5yA7myOhcKWLlri4oW+/+rsEg59fdf2lC7lmQL/nhLPLCJky51dSYi0zgOrp9QBhlkHoYdzIBJIwYz2cUv4YAAAAASUVORK5CYII="/>
        ${getIn18Text('TIANJIAYOUXIANGZHANG')}
      </span>`,
            action: () => {
                trackApi.track('pc_mail_addEmail_blankPage', { action: 'add' });
                eventApi.sendSysEvent({
                    eventName: 'toAddAccount',
                    eventStrData: '',
                    eventData: null,
                });
            },
            judgeShowBtn: () => {
                var _a;
                if (((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname) === '/') {
                    try {
                        trackApi.track('pc_mail_addEmail_blankPage', { view: true });
                    }
                    catch (error) { }
                    return true;
                }
                return false;
            },
        },
    },
    toTop: {
        title: getIn18Text('YOUJIANZHIDING '),
        desc: getIn18Text('ZHONGYAOYOUJIANYI'),
        imgUrl: Top,
    },
    customFolder: {
        title: getIn18Text('DUOJIWENJIANJIA'),
        desc: getIn18Text('YOUXUFENLEIWANG'),
        imgUrl: MultipleFiles,
    },
    classify: {
        title: getIn18Text('LAIXINFENLEI '),
        desc: getIn18Text('SHEZHILAIXINFEN11'),
        imgUrl: MailClassify,
    },
    feedback: {
        title: getIn18Text('WENTIFANKUI '),
        desc: getIn18Text('RUONINXUYAOREN'),
        imgUrl: FeedbackImg,
    },
    template: {
        title: getIn18Text('YOUJIANMOBAN '),
        desc: getIn18Text('ZHONGFUYOUJIANSHE'),
        imgUrl: MailTemplate,
    },
    signature: {
        title: getIn18Text('DINGZHIQIANMING '),
        desc: getIn18Text('LINGXIDINGZHIYOU'),
        imgUrl: MailSignature,
    },
    aggregation: {
        title: getIn18Text('ZHINENGYOUJIAN '),
        desc: getIn18Text('TONGZHUTIYOUJIAN'),
        imgUrl: MailAggregation,
    },
    readStatus: {
        title: getIn18Text('YIDUWEIDU '),
        desc: getIn18Text('CHAKANYOUJIANYUE'),
        imgUrl: Read,
    },
    revocation: {
        title: getIn18Text('CHEHUIYOUJIAN '),
        desc: getIn18Text('CHEHUIYOUJIANZHONG'),
        imgUrl: Withdraw,
    },
    redFlag: {
        title: getIn18Text('HONGQIYOUJIAN '),
        desc: getIn18Text('ZHONGYAOYOUJIANHONG'),
        imgUrl: Flag,
    },
    nativeGuide: {
        title: getIn18Text('DUODUANZHICHI '),
        desc: getIn18Text('XIAZAISHOUJIDUAN'),
        imgUrl: Native,
    },
};
export const guideConfig = {
    1: {
        sort: ['moreAccount', 'aggregation', 'toTop', 'customFolder', 'classify', 'feedback', 'nativeGuide'],
        config: {
            moreAccount: configMap.moreAccount,
            aggregation: configMap.aggregation,
            toTop: configMap.toTop,
            customFolder: configMap.customFolder,
            classify: configMap.classify,
            feedback: configMap.feedback,
            nativeGuide: configMap.nativeGuide,
        },
    },
    3: {
        sort: ['readStatus', 'revocation', 'template', 'signature', 'nativeGuide'],
        config: {
            readStatus: configMap.readStatus,
            revocation: configMap.revocation,
            template: configMap.template,
            signature: configMap.signature,
            nativeGuide: configMap.nativeGuide,
        },
    },
    '-1': {
        sort: ['redFlag', 'nativeGuide'],
        config: {
            redFlag: configMap.redFlag,
            nativeGuide: configMap.nativeGuide,
        },
    },
    '-100': {
        sort: ['moreAccount', 'toTop', 'customFolder', 'readStatus', 'revocation', 'redFlag', 'nativeGuide'],
        config: {
            moreAccount: configMap.moreAccount,
            toTop: configMap.toTop,
            customFolder: configMap.customFolder,
            readStatus: configMap.readStatus,
            revocation: configMap.revocation,
            redFlag: configMap.redFlag,
            nativeGuide: configMap.nativeGuide,
        },
    },
};
